import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import Mgr from "@/services/SsoService";
import VueGoogleMap from "vuejs-google-maps";


Vue.use(Vuex);


export default new Vuex.Store({
    state: {
        count: 0,
        error: "",
        searchString: "",
        searchType: "",
        searchResult: [],
        lastSearchResult: [],
        searchingSiret: false,
        searchingEtab: false,
        etablissement: {},
        cacheEtablissements: [],
        historiqueConsultes: [],
        googleMapInit: false,
        googlekey: "",
        userInfo:"",
        userLea:false,
        applicationsource: process.env.VUE_APP_SOURCE || "OB4S",
        applicationKey : process.env.VUE_APP_APP_ID || "",
        bilanInpiList: [],
        okBilan: false,
        pingBilan: 0,
        isDownloadingBilan: "",
        apiurl: process.env.VUE_APP_URL || "http://localhost:5000/v2/", //  "https://api-entreprise-dev.api-dev.dsm.apps.generali.fr/v2/"
        warnings: [],
    },

    mutations: {
        searchingSiret(state, searchstate) {
            state.searchingSiret = searchstate
        },
        searchingEtab(state, searchstate) {
            state.searchingEtab = searchstate
        },
        increment(state) {
            state.count++
        },
        setSearchResult(state, searchresult) {
            state.searchResult = searchresult
        },
        setGoogleInitialized(state) {
            state.googleMapInit = true
        },
        saveSearchResult(state, data) {
            state.lastSearchResult = data
        },
        setError(state, error) {
            state.error = error
        },
        setOkBilan(state, value) {
            state.okBilan = value
        },
        setPingBilan(state, value) {
            state.pingBilan = value
        },
        setWarnings(state, value) {
            state.warnings = value
        },
        setSearchType(state, value) {
            state.searchType = value
        },
        setEtablissement(state, {siret, etab}) {

            state.etablissement = etab.data
            state.siret = siret
        },
        resetEtablissement(state) {

            state.etablissement = null
            state.siret = null
        },
        addEtablissementToCache(state, {etab}) {
            state.cacheEtablissements.push(etab)
        },
        addEtablissementToConsute(state, etab) {
            state.historiqueConsultes.push(etab)
        },
        setGoogleKey(state, key) {
            state.googlekey = key
        },
        setUserInfo(state, info) {
            state.userInfo = info
        },
        setUserLea(state, info) {
            state.userLea = info
        },
        setBilanInpi(state, bilan) {
            state.bilanInpiList = bilan
        },
    },
    getters: {
        googleMapKey: (state) => state.googlekey,
        googleIsInitilized: (state) => state.googleMapInit,
        userInfo:(state) => (state.userInfo),
        userLea:(state) => (state.userLea),

        home: (state) => {
            try {
                return state.historiqueConsultes.length == 0 &&
                    state.searchResult.length == 0 &&
                    !state.searchingEtab &&
                    !state.searchingSiret &&
                    state.searchString == ""

            } catch (e) {
                return {}
            }
        },
        etablissemement: (state) => state.etablissement,

        searchResult: (state) => state.searchResult,
        BilanInpiList: (state) => {
            function compareBilan( a, b ) {
              if ( a.path > b.path ){
                return -1;
              }
              if ( a.path < b.path ){
                return 1;
              }
              return 0;
            }
            try {
                return state.bilanInpiList.sort(compareBilan)
            } catch (e) {
                return {}
            }
        },
        EtablissementIdentite: (state, data) => {
            try {
                return state.etablissement.get("identite", {}).get("donnees", {}).get(data, {})
            } catch (e) {
                return {}
            }
        },
        EtablissementBTP: (state, data) => {
            try {
                return state.etablissement.get("certificats", {}).get("donnees", {}).get(data, {})
            } catch (e) {
                return {}
            }
        },
        condition: (state) => (bloc, sousbloc, item = null, field = null) => {


            try {
                var condiii = state.etablissement && bloc in state.etablissement
                    && sousbloc in state.etablissement[bloc]
                    && (item == null || item in state.etablissement[bloc][sousbloc])
                    && (field == null || (field in state.etablissement[bloc][sousbloc][item] && state.etablissement[bloc][sousbloc][item][field] != null))
                return condiii
            } catch (e) {
                console.log(e)
            }
        },
        getbloc: (state) => (bloc, sousbloc, item = null, defaultValue = null, field = null) => {
            if (state.etablissement && bloc in state.etablissement && sousbloc in state.etablissement[bloc]) {
                if (item != null) {
                    if (item in state.etablissement[bloc][sousbloc]) {
                        if (field != null) {
                            if (field in state.etablissement[bloc][sousbloc][item]) {
                                return state.etablissement[bloc][sousbloc][item][field]
                            } else {
                                return defaultValue
                            }
                        }
                        return state.etablissement[bloc][sousbloc][item]
                    } else {
                        return defaultValue
                    }
                } else {
                    return state.etablissement[bloc][sousbloc]
                }
            }
            return defaultValue
        },


    },
    actions: {
        getUserInfo(store) {
             var mgr = new Mgr();

            mgr.getRole().then((role) => {
                if (role) {
                    //console.log("role : " + JSON.stringify(role))

                } else {
                  //console.log("pas de role")
                }
            })

            mgr.getUser().then((user) => {
                if (user) {
                    //console.log("user : " + JSON.stringify(user))

                } else {
                  //console.log("pas de user")
                }
            })




            mgr.getRoleLea().then((rolelea) => {
                if (rolelea) {
                    //console.log("rolelea : " + JSON.stringify(rolelea))

                } else {
                  //console.log("pas de rolelea")
                }
            })


            mgr.getProfile().then((profile) => {
                if (profile) {
                    //console.log("profile : " + JSON.stringify(profile))
                    store.commit("setUserInfo", profile.name + " (" + profile.preferred_username + ")");
                    store.commit("setUserLea", profile.email.includes("agence"));
                } else {
                    store.commit("setUserInfo", " - ");
                    store.commit("setUserLea", false);
                }
            })
        },
        findSiretFor(store, {what, active = null}) {
            store.commit("setSearchType", "normalSearch")
            store.commit("setError", null)
            store.commit("setSearchResult", [])
            var request = "/search/" + what + (active != null && active ? "?active=true" : "")
            var mgr = new Mgr();

            sessionStorage.setItem("from", request);



            mgr.getAccessToken().then((accessToken) => {
                if (what) {
                    // est-ce un siret ou un siren ?
                    // si oui lancer également le chargement du détail
                    if (!isNaN(what) && (what.length == 9 || what.length == 14)) {
                        store.dispatch('getEtablissement', what)
                    }
                    const apiUrl = store.state.apiurl + 'entreprise' + request
                    store.commit("searchingSiret", true)
                    axios.get(apiUrl
                        , {
                            headers: {
                                'Authorization': `Bearer ` + accessToken,
                                'Apikey': store.state.applicationKey ,
                                'X-Application-ID' : store.state.applicationsource
                            }
                        }
                    ).then((response) => {
                        store.commit("setSearchResult", Array.from(response.data, x => x._source))
                        store.commit("searchingSiret", false)
                        // si une seule réponse => afficher l'entreprise

                        return response.data
                    }).catch(error => {
                        store.commit("setError", error)
                        store.commit("setSearchResult", [])
                        store.commit("searchingSiret", false)
                        if (error.response) {
                          console.log(error.response.data);
                          console.log(error.response.status);
                          console.log(error.response.headers);
                          if (error.response.status==401) {
                              //var user = new Mgr();
                              //user.signOut();
                              //user.signIn();
                              console.log("sign out status code = "+error.response.status)
                          }
                        }
                        return []

                    });
                }
            });


        },
        searchFindSiretFor(store, payload) {
            store.commit("setSearchType", "advancedSearch")
            store.commit("setError", null)
            store.commit("setSearchResult", [])

            var request = "/find/"
            var mgr = new Mgr();

            sessionStorage.setItem("from", request);



            mgr.getAccessToken().then((accessToken) => {
                const apiUrl = store.state.apiurl + 'entreprise' + request
                store.commit("searchingSiret", true)
                axios.post(apiUrl, {
                    filter: payload
                }, {
                    headers: {
                        'Authorization': `Bearer ` + accessToken,
                        'Apikey': store.state.applicationKey ,
                        'X-Application-ID' : store.state.applicationsource
                    },
                }).then((response) => {
                    store.commit("setSearchResult", Array.from(response.data, x => x._source))
                    store.commit("searchingSiret", false)
                    // si une seule réponse => afficher l'entreprise
                    return response.data
                }).catch(error => {
                    store.commit("setError", error)
                    store.commit("setSearchResult", [])
                    store.commit("searchingSiret", false)
                    if (error.response) {
                      //console.log(error.response.data);
                      //console.log(error.response.status);
                      //console.log(error.response.headers);
                      if (error.response.status==401) {
                          //var user = new Mgr();
                          //user.signOut();
                          //user.signIn();
                          console.log("sign out status code = "+error.response.status)
                      }
                    }
                    return []
                });
            });
        },
        getHistory(store) {
            store.commit("saveSearchResult", store.state.searchResult)
            store.commit("setSearchResult", store.state.historiqueConsultes)
            window.scrollTo(0, 0);
        },
        getResults(store) {
            store.commit("setSearchResult", store.state.lastSearchResult)
            window.scrollTo(0, 0);
        }
        ,
        initGoogleMapKeys(store) {
            if (!store.state.googleMapInit) {
                var mgr = new Mgr();

                mgr.getAccessToken().then((accessToken) => {

                    const apiUrl = store.state.apiurl + 'key/GOOGLE_MAP_KEY'
                    axios.get(apiUrl
                        , {
                            headers: {
                                'Authorization': `Bearer ` + accessToken,
                                 'X-Application-ID' : store.state.applicationsource,
                                'Apikey': store.state.applicationKey ,

                            }
                        }
                    ).then((response) => {
                        store.commit("setGoogleKey", response.data)

                        Vue.use(VueGoogleMap, {
                            load: {
                                apiKey:  this.$store.getters.googleMapKey,
                                libraries: [],
                            }
                        })
                        store.commit("setGoogleInitialized")
                        return true
                    }).catch(error => {
                        console.log(error);

                        return false
                    });
                });
            }

        },

        downloadBilan (store, pl) {
            store.state.isDownloadingBilan = pl['year']
            var mgr = new Mgr();
            mgr.getAccessToken().then((accessToken) => {
                axios.post(store.state.apiurl + 'entreprise/siret/' + pl['siret'],
                    {
                        "documents": pl['id'],
                    }
                    ,{
                        headers: {
                            'Authorization': `Bearer ` + accessToken,
                            'Apikey':store.state.applicationKey ,
                            'X-Application-ID' : store.state.applicationsource
                        },
                        responseType: 'arraybuffer',
                    }
                ).then((response) => {
                    store.state.isDownloadingBilan = ""
                    var blob = new Blob([response.data], { type: 'application/pdf' })
                    var link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = "Bilan_INPI_" + pl['siret'].slice(0, 9) + "_" + pl['year'] + ".pdf"
                    link.click()
                }).catch(error => {

                    store.commit("setError", error)
                    if (error.response) {
                        //console.log(error.response.data);
                        //console.log(error.response.status);
                        //console.log(error.response.headers);
                        if (error.response.status == 401) {
                            console.log("sign out status code = " + error.response.status)

                        }
                    }
                    return null
                });
            })
        },
        getAlertes (store, {etab}) {

            store.state.warnings = []
            for (var item in etab.data) {
                item = etab.data[item]
                if ("alertes" in item) {
                    for (var alerte in item["alertes"]) {
                        alerte = item["alertes"][alerte]
                        alerte = {
                          "msg": alerte.valeur,
                          "bloc": "" // TODO: ...
                        }

                        store.state.warnings.push(alerte)
                    }
                }
            }
        },
        getBilanList (store, siret) {
            var mgr = new Mgr();
            mgr.getAccessToken().then((accessToken) => {

                axios.post(store.state.apiurl + 'entreprise/siret/' + siret,
                    {
                        "documents": -1,
                    }
                    ,{
                        headers: {
                            'Authorization': `Bearer ` + accessToken,
                            'Apikey':store.state.applicationKey ,
                            'X-Application-ID' : store.state.applicationsource
                        }
                    }
                ).then((response) => {
                    var tmp = response.data
                    store.commit("setBilanInpi", tmp);
                    for (var idx in tmp) {
                        var bilan = tmp[idx]
                        if (bilan.path == 'processing')
                            return 0
                    }
                    store.commit('setOkBilan', true)
                }).catch(error => {
                    if (error.response) {
                          //console.log(error.response.data);
                          //console.log(error.response.status);
                          //console.log(error.response.headers);
                          if (error.response.status==401) {
                               console.log("sign out status code = "+error.response.status)
                          }
                        }
                    return null
                });
            })
        },

        getEtablissement(store, siret) {
            if (siret) {
                store.commit("setError", null)
                store.commit("setOkBilan", false)
                store.commit("resetEtablissement")
                store.commit("setWarnings", [])
                window.scrollTo(0, 0);
                // search in the store if we have this siret
                var isAgent = store.state.userLea
                //console.log("isAgent : "+isAgent)
                var etab = store.state.cacheEtablissements.find(etablissement => etablissement.siret === siret);
                if (etab != null  ) {
                    // set etablissement
                    if (etab.data === null || etab.data.evenements ===null || etab.data.evenements.donnees == null || etab.data.evenements.donnees.inpi_bilans === null || etab.data.evenements.donnees.inpi_bilans.valeur[0] === '0')
                        store.commit("setBilanInpi", [])
                    else
                        store.dispatch("getBilanList", siret)
                    store.commit("setEtablissement", {siret, etab})
                } else {
                    // add selected etab to consulted list for history
                    // search in the SearchResultat if we have this siret
                    var siretEtab = store.state.searchResult.find(etablissement => etablissement.siret === siret);
                    store.commit("addEtablissementToConsute", siretEtab)
                    store.commit("searchingEtab", true)
                    const apiUrl = store.state.apiurl + 'entreprise/siret/' + siret;
                    const params = {
                        "fields": ["valeur", "libelle"], // TODO: ajouter "source" ici pour le support des sources
                        //"filters": ["identite", "info", "contact", "administratif",  "certificats", "concurrence", "environnement","risque"],
                        "output": "structure",
                        "free_only": isAgent
                    }

                    var mgr = new Mgr();
                    store.commit("setBilanInpi", [])
                    sessionStorage.setItem("from", "/siret/" + siret);
                    mgr.getAccessToken().then((accessToken) => {
                        axios.post(apiUrl,
                            params
                            ,{
                                headers: {
                                    'Authorization': `Bearer ` + accessToken,
                                    'Apikey':store.state.applicationKey ,
                                    'X-Application-ID' : store.state.applicationsource
                                }
                            }
                        ).then(async (response) => {
                            etab = {"siret": siret, data: response.data}
                            // set etablissement and save it to cache
                            store.commit("addEtablissementToCache", {etab})
                            store.commit("setEtablissement", {siret, etab})
                            store.commit("searchingEtab", false)
                            var bilanOk = store.getters.getbloc("evenements", "donnees", "inpi_bilans", null, "valeur")

                            store.dispatch("getAlertes", {etab})

                            if (bilanOk!=null) {
                            if (bilanOk[0] == "1") {
                                store.dispatch('getBilanList', siret)
                                while (!store.state.okBilan) {
                                    store.dispatch('getBilanList', siret)
                                    await new Promise(r => setTimeout(r, 20000))
                                    if (siret !== store.state.siret || store.state.pingBilan >= 50) {
                                        store.commit("setOkBilan", false)
                                        store.commit("setPingBilan", 0)
                                        return
                                    }
                                    store.state.pingBilan++
                                }
                                store.commit("setOkBilan", false)
                            }
                            }
                        }).catch(error => {
                            store.commit("setError", error)
                            store.commit("searchingEtab", false)
                            if (error.response) {
                                  //console.log(error.response.data);
                                  //console.log(error.response.status);
                                  //console.log(error.response.headers);
                                  if (error.response.status==401) {

                                       //var user = new Mgr();
                                       //user.signOut();
                                       //user.signIn();
                                       console.log("sign out status code = "+error.response.status)

                                  }
                                }
                            return null
                        });
                    });
                }
            }
        }
    },

    modules: {}
})
